import { render, staticRenderFns } from "./Interventi.vue?vue&type=template&id=a04e352c&"
var script = {}
import style0 from "./Interventi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports